import { c as _c } from "react-compiler-runtime";
import I18n from 'I18n';
import { useMemo } from 'react';
export default function useButtonA11yProps(t0) {
  "use memo";

  const $ = _c(10);
  const {
    i18nKey,
    onClick,
    allowTabbing: t1
  } = t0;
  const allowTabbing = t1 === undefined ? true : t1;
  let t2;
  let t3;
  if ($[0] !== i18nKey) {
    t3 = I18n.text(i18nKey);
    $[0] = i18nKey;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== allowTabbing) {
    t4 = allowTabbing ? {
      tabIndex: 0
    } : {};
    $[2] = allowTabbing;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== onClick) {
    t5 = e => {
      if (e.key === "Enter" || e.key === " ") {
        onClick(e);
      }
    };
    $[4] = onClick;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t3 || $[7] !== t4 || $[8] !== t5) {
    t6 = Object.assign({
      role: "button",
      "aria-label": t3
    }, t4, {
      onKeyDown: t5
    });
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  t2 = t6;
  return t2;
}